import { render, staticRenderFns } from "./albumFilter.vue?vue&type=template&id=54aa7054&"
import script from "./albumFilter.vue?vue&type=script&lang=js&"
export * from "./albumFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports